import {
  OreButton,
  OreHeading,
  OreInput,
  OreStack,
  OreText,
  SvgResetData,
} from '@edenredespana/oreneta'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { AutoEnrollmentTranslation } from '@/AutoEnrollment/ui/autoEnrollmentTranslation'
import { useAutoEnrollment } from '@/AutoEnrollment/ui/context'
import { FillWithOwnerCases, Step1Form } from '@/AutoEnrollment/ui/hooks'
import { handleErrors } from '@/Shared/ui/form'

export const Step1PaymentContactData = (): JSX.Element => {
  const { t } = useTranslation()
  const { register, formState } = useFormContext<Step1Form>()
  const { errors } = handleErrors(formState)

  const { fillWithOwnerData } = useAutoEnrollment()

  return (
    <OreStack placeContent="stretch" space="large">
      <OreHeading as="h2" size="headline-md">
        {t(AutoEnrollmentTranslation.paymentContactData.title)}
      </OreHeading>
      <OreText>{t(AutoEnrollmentTranslation.paymentContactData.description)}</OreText>
      <OreStack direction="row" placeContent="start">
        <OreButton
          category={'tertiary'}
          icon={<SvgResetData />}
          iconAlign={'left'}
          onClick={() => fillWithOwnerData(FillWithOwnerCases.payment)}
          data-testid="fillWithOwnerData"
        >
          {t(AutoEnrollmentTranslation.paymentContactData.fillWithOwnerData)}
        </OreButton>
      </OreStack>
      <OreInput
        {...register('paymentName')}
        {...errors('paymentName')}
        id="paymentName"
        label={t(AutoEnrollmentTranslation.paymentContactData.data.name.label)}
        placeholder={t(
          AutoEnrollmentTranslation.paymentContactData.data.name.placeholder,
        )}
        required
        maxLength={20}
      />
      <OreStack direction="row" space="large" placeContent="stretch" sameSize>
        <OreInput
          {...register('paymentSurname1')}
          {...errors('paymentSurname1')}
          id="paymentSurname1"
          label={t(AutoEnrollmentTranslation.paymentContactData.data.surname1.label)}
          placeholder={t(
            AutoEnrollmentTranslation.paymentContactData.data.surname1.placeholder,
          )}
          required
          maxLength={20}
        />
        <OreInput
          {...register('paymentSurname2')}
          {...errors('paymentSurname2')}
          id="paymentSurname2"
          label={t(AutoEnrollmentTranslation.paymentContactData.data.surname2.label)}
          placeholder={t(
            AutoEnrollmentTranslation.paymentContactData.data.surname2.placeholder,
          )}
          maxLength={20}
        />
      </OreStack>
      <OreStack direction="row" space="large" placeContent="stretch" sameSize>
        <OreInput
          {...register('paymentEmail')}
          {...errors('paymentEmail')}
          id="paymentEmail"
          label={t(AutoEnrollmentTranslation.paymentContactData.data.email.label)}
          type="email"
          placeholder={t(
            AutoEnrollmentTranslation.paymentContactData.data.email.placeholder,
          )}
          required
          maxLength={255}
        />
        <OreInput
          {...register('paymentPhone')}
          {...errors('paymentPhone')}
          id="paymentPhone"
          label={t(AutoEnrollmentTranslation.paymentContactData.data.phone.label)}
          type="tel"
          placeholder={t(
            AutoEnrollmentTranslation.paymentContactData.data.phone.placeholder,
          )}
          required
          maxLength={255}
        />
      </OreStack>
    </OreStack>
  )
}
